
webpack.register(
    'modules/right-rail/custom-merchandise/custom-merchandise',
    function() {
        return import('modules/right-rail/custom-merchandise/custom-merchandise');
    },
    true
);